export default __webpack_public_path__ + "static/media/illustration-consumer.9e7b610a.png";